import {
    getStyleguideSectionById,
    getStyleguideSections,
} from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideSelectors";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface RemoveStyleguideSectionParameter {
    id: string;
}

type HandlerType = Handler<RemoveStyleguideSectionParameter>;

export const DispatchRemoveStyleguideSection: HandlerType = props => {
    const state = props.getState();
    const section = getStyleguideSectionById(state, props.parameter.id);
    const sections = getStyleguideSections(state);

    if (section) {
        props.dispatch({
            type: "Toolkit/Components/Styleguide/RemoveStyleguideSection",
            id: props.parameter.id,
            sections,
        });
    }
};

export const chain = [DispatchRemoveStyleguideSection];

const removeStyleguideSection = createHandlerChainRunner(chain, "RemoveStyleguideSection");

export default removeStyleguideSection;
